
riot.tag2('section-list', '  <div class="row">\n    <div class="col-md-4 col-xs-12">\n      <catalog name="section-page" object="SectionPage" cols="{pageCols}" reload="true" onclick="{pageclick}" disable-limit="true" disable-col-select="true" remove="{remove}" handlers="{handlers}" store="section-list">\n        <yield to="body">\n          <datatable-cell name="enabled">\n            <button class="btn btn-default btn-sm" type="button" onclick="{handlers.boolChange}" ontouchend="{handlers.boolChange}" ontouchstart="{stopPropagation}"><i class="fa {row.enabled ? &quot;fa-eye text-active&quot; : &quot;fa-eye-slash text-noactive&quot;} "></i></button>\n          </datatable-cell>\n          <datatable-cell name="title">{row.title}</datatable-cell>\n          <datatable-cell name="code">{row.code}</datatable-cell>\n          <datatable-cell name="page">{row.page}</datatable-cell>\n\n        </yield>\n      </catalog>\n    </div>\n    <div class="col-md-8 col-xs-12">\n      <section-list-items name="section-item" filters="{categoryFilters}" section="{idSection}"></section-list-items>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.collection = 'SectionPage';
self.idSection = 0;
self.categoryFilters = [{ field: 'idSection', sign: 'IN', value: self.idSection }];

self.mixin('remove');

var route = riot.route.create();

self.handlers = {
    checkPermission: self.checkPermission,
    permission: self.permission,
    boolChange: function boolChange(e) {
        var _this = this;
        e.stopPropagation();
        e.stopImmediatePropagation();
        _this.row[_this.opts.name] = _this.row[_this.opts.name] ? 0 : 1;
        self.update();

        var params = {};
        params.id = _this.row.id;
        params[_this.opts.name] = _this.row[_this.opts.name];
        API.request({
            object: 'SectionPage',
            method: 'Save',
            data: params,
            error: function error(response) {
                rows.forEach(function (item) {
                    item[field] = oldValues[item.id][field];
                });
                self.update();
            }
        });
    }
};

self.pageCols = [{ name: 'enabled', value: 'Вид' }, { name: 'code', value: 'Код' }, { name: 'title', value: 'Наименование' }, { name: 'page', value: 'Страница' }];

self.one('updated', function () {});

self.pageclick = function (e) {
    var rows = self.tags['section-page'].tags.datatable.getSelectedRows();
    self.idSection = rows[0].idSection;
    self.categoryFilters = [{ field: 'idSection', sign: 'IN', value: self.idSection }];
    self.update();
    observable.trigger('section-reload');
};

self.on('mount', function () {});
});


// WEBPACK FOOTER //
// ./pages/sections/section-list.tag